import { Button, DialogActions, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import assetService from '../../../../services/AssetService';
import { format } from 'date-fns';

const AssetLogs = ({ row, onCancelChanges }) => {
  const [assetLogs, setAssetLogs] = useState([]);

  useEffect(() => {
    const fetchAssetLogs = async () => {
      try {
        const assetLogs = row?.assetId && (await assetService.getAssetLogs(row.assetId));

        const operatorLogs = assetLogs?.data?.data?.operator;
        const commentLogs = assetLogs?.data?.data?.comment;

        let combinedLogs = [];

        if (operatorLogs.length > 0) {
          for (let i = 0; i < operatorLogs.length; i++) {
            const currentPos = operatorLogs[i];
            const nextPos = operatorLogs[i + 1];

            combinedLogs.push({
              ...currentPos,
              type: 'operator',
              endDate: nextPos?.assignedDate || null,
              sortDate: new Date(currentPos.assignedDate)
            });
          }
        }

        if (commentLogs.length > 0) {
          for (let i = 0; i < commentLogs.length; i++) {
            const currentPos = commentLogs[i];

            combinedLogs.push({ ...currentPos, type: 'comment', sortDate: new Date(currentPos.updatedAt) });
          }
        }

        //sort combined logs by descending order
        combinedLogs.sort((a, b) => b.sortDate - a.sortDate);

        setAssetLogs(combinedLogs);
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.log('error is:', error);
      }
    };
    fetchAssetLogs();
  }, [row.assetId]);

  return (
    <div>
      <DialogContent style={{ height: '700px' }}>
        <ul>
          {assetLogs.map((log) => {
            if (log.type === 'operator') {
              return (
                <li key={log.assignedDate}>
                  Operator <b>{log.operator}</b> was assigned to this asset on{' '}
                  {format(new Date(log.assignedDate), 'dd/MM/yyyy')}
                  {log?.endDate && <span> to {format(new Date(log.endDate), 'dd/MM/yyyy')}</span>}
                  {log?.updatedBy?.DisplayName ? (
                    <span>
                      {' '}
                      by <b>{log?.updatedBy?.DisplayName}</b>{' '}
                    </span>
                  ) : (
                    ''
                  )}
                </li>
              );
            } else if (log.type === 'comment') {
              return (
                <li key={log.updatedAt}>
                  Comment: {log.comment} on {format(new Date(log.updatedAt), 'dd/MM/yyyy')}
                  {log?.updatedBy?.DisplayName && (
                    <span>
                      {' '}
                      by <b>{log.updatedBy.DisplayName}</b>
                    </span>
                  )}
                </li>
              );
            }
            return null;
          })}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelChanges} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </div>
  );
};

export default AssetLogs;

AssetLogs.propTypes = {
  row: PropTypes.any,
  onCancelChanges: PropTypes.func
};
